import { BlurView } from 'expo-blur';
import { LinearGradient } from 'expo-linear-gradient';
import { type ColorSchemeName, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb, View } from 'smoothie';

const ProgressiveBlurHeader = ({
    pageBackgroundColor,
}: {
    pageBackgroundColor: string;
}) => {
    const insets = useSafeAreaInsets();
    const height = insets.top;
    // const colorScheme = useColorScheme();  // Use this when supporting dark mode
    const colorScheme = 'light' as ColorSchemeName;

    return (
        <View style={styles.absoluteFill} height={height} zIndex={10}>
            {!isWeb && (
                <BlurView
                    tint={colorScheme ?? 'default'}
                    intensity={9}
                    style={{ ...styles.absoluteFill, height }}
                />
            )}
            <LinearGradient
                colors={[pageBackgroundColor, 'rgba(255,255,255,0)']}
                style={{
                    height,
                    width: '100%',
                    position: 'absolute',
                    top: height * -0.4,
                }}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    absoluteFill: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        overflow: 'hidden', // Important for masking
    },
});

export default ProgressiveBlurHeader;
